<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Add an FTP Account
        </gg-card-header>
        <gg-card-text class="pa-4">
          <ftp-account-form @account-created="reloadTable"></ftp-account-form>
        </gg-card-text>
      </gg-card>
    </v-col>
    <!-- FTP Accounts -->
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          FTP Accounts
        </gg-card-header>
        <gg-card-text>
          <ftp-accounts-table :loading="loading" @reload="reloadTable"></ftp-accounts-table>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import FtpAccountForm from '@/components/Services/Hosting/Shared/Ftp/FtpAccountForm'
import FtpAccountsTable from '@/components/Services/Hosting/Shared/Ftp/FtpAccountsTable'

export default {
  name: 'FtpAccountsView',
  components: {
    FtpAccountForm,
    FtpAccountsTable,
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      getFtpPort: 'ftp/getFtpPort',
      getFtpAccountsList: 'ftp/getFtpAccountsList',
      reportError: 'reportError',
    }),
    async reloadTable () {
      this.loading = true
      try {
        await this.getFtpAccountsList(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
        this.loading = false
      }
      this.loading = false
    },
  },
  async created () {
    try {
      await this.getFtpPort(this.$route.query.user)
    } catch (e) {
      this.reportError(e)
    }
  },
}
</script>
